/**
 * Notification class.
 */
export class Notification {
  /**
   * Constructor for Notification class.
   *
   * @param {string} message - String which must match with a locale property.
   * @param {string} severity - The Message level (error, warning, info, success).
   * @param {number} autoHideDuration - The duration how long the message is vissible.
   */
  constructor(message, severity, autoHideDuration) {
    this.message = message;
    this.severity = severity;
    this.autoHideDuration = autoHideDuration;
  }
}
